export default __webpack_public_path__ + "static/media/SusiePak.6c67fc01.png";